import React from 'react';
import { SvgIcon } from './svg-icon';

export const Send = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M20.4328 3.0422L3.22494 10.5422C2.92025 10.6875 2.92963 11.1234 3.239 11.2594L7.89369 13.8891C8.17025 14.0438 8.51244 14.0109 8.7515 13.8047L17.9296 5.8922C17.9906 5.84063 18.1359 5.7422 18.1921 5.79845C18.2531 5.85938 18.1593 6.00001 18.1078 6.06095L10.1671 15.0047C9.94681 15.2531 9.914 15.6188 10.0921 15.9L13.1343 20.7797C13.2843 21.075 13.7109 21.0703 13.8468 20.7703L20.9624 3.56251C21.1171 3.22501 20.7656 2.88282 20.4328 3.0422Z" />
  </SvgIcon>
);
